import { css } from "@emotion/react";
import type { ComponentProps } from "react";

export const Section = (props: ComponentProps<"section">) => {
  const { children, title, ...others } = props;

  return (
    <section
      css={css`
        @media print {
          padding-top: 24px;
        }
      `}
      {...others}
    >
      <h4
        css={css`
          margin: 0 0 calc(2 * var(--report-root-font-size)) 0;
          font-size: calc(1.7 * var(--report-root-font-size));
          font-weight: 500;
          line-height: calc(1.7 * var(--report-root-font-size));
        `}
      >
        {title}
      </h4>
      {children}
    </section>
  );
};
